export default {
    address: {
        name: "ITU LAN",
        partOf: "part of",
        studentCouncil: "Student Council of IT University of Copenhagen",
        location: "Rued Langgaardsvej 7",
        zipCode: "2300 København S",
    },
    cvr: "CVR NR: 32481809",
    email: "info@itulan.dk",
}